<template>
    <div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
        <div class="row">
            <h1 class="page-header">
                Customers
            </h1>
        </div>
        <div id="flashes" class="row"></div>
        <div class="row">
            <button type="button" class="btn btn-primary" data-toggle="modal" data-backdrop="static" id="new_button" data-target="#modal" data-user-id="-1">
                <i class="fa fa-plus"></i> New Customer</button>
        </div>
        &nbsp;
        <div id="loading">
            <i class="fa fa-spinner fa-spin fa-4x"></i>
        </div>
        <div id="emptyMessage" class="row" style="display:none;">
            <div class="alert alert-info">
                No customers created yet. Let's create one!
            </div>
        </div>
        <div class="row">
            <table id="customersTable" class="table" style="display:none;">
                <thead>
                    <tr>
                        <th>Customer ID</th>
                        <th>Customer name</th>
                        <th>Phishing flag</th>
                        <th>Usb flag</th>
                        <th>Quishing flag</th>
                        <th class="col-md-2 no-sort"></th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" onclick="dismiss()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" id="customerModalLabel">New Customer</h4>
                  
                </div>
                <div class="modal-body">
                    <div class="row" id="modal.flashes"></div>
                    <label class="control-label" for="name"><span>*</span>Name:</label>
                    <form class="form-group" id="customer_form">
                        <!-- da rivedere -->
                        <!--<input type="hidden" readonly="" id="identificativo" name="id" value="-1" display="none">-->
                        <input type="text" class="form-control" name="customer_name" ng-model="customer.name" placeholder="Customer name" id="name" autofocus required />
                         <div class="checkbox checkbox-primary">
                            <input id="customer_phishing_locked_checkbox" type="checkbox" >
                            <label for="customer_phishing_locked_checkbox">Phishing</label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <input id="customer_usb_locked_checkbox" type="checkbox" >
                            <label for="customer_usb_locked_checkbox">USB</label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <input id="customer_quishing_locked_checkbox" type="checkbox" >
                            <label for="customer_quishing_locked_checkbox">Quishing</label>
                        </div>
                    </form>
                    <br />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal" id="modalClose" onclick="dismiss()">Close</button>
                    <button type="button" class="btn btn-primary" id="modalSubmit">Save Customer</button>
                </div>
            </div>
        </div>
    </div>
    <!--
    <div class="modal fade" id="modalModify" tabindex="-1" role="dialog" aria-labelledby="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" onclick="dismiss()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title" id="customerModalLabel">New Customer</h4>
                    <input type="hidden" readonly="" name="id" value="-1" display="none">
                </div>
                <div class="modal-body">
                    <div class="row" id="modal.flashes"></div>
                    <label class="control-label" for="name"><span>*</span>Name:</label>
                    <form class="form-group" id="customer_form">
                        <input type="text" class="form-control" name="customer_name" ng-model="customer.name" placeholder="Customer name" id="name" autofocus required />
                         <div class="checkbox checkbox-primary">
                            <input id="customer_phishing_locked_checkbox" type="checkbox" >
                            <label for="customer_phishing_locked_checkbox">Phishing</label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <input id="customer_usb_locked_checkbox" type="checkbox" >
                            <label for="customer_usb_locked_checkbox">USB</label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <input id="customer_quishing_locked_checkbox" type="checkbox" >
                            <label for="customer_quishing_locked_checkbox">Quishing</label>
                        </div>
                    </form>
                    <br />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal" id="modalClose" onclick="dismiss()">Close</button>
                    <button type="button" class="btn btn-primary" id="modalSubmit" onclick="modifyCustomer()">Save Customer</button>
                </div>
            </div>
        </div>
    </div>
-->
</template>
  
<script>
export default {
  name: 'CustomersComponent',
  //props: {
  //  msg: String
  //}
  mounted() {

  let customScript = document.createElement('script')

  customScript.setAttribute('src', '/scripts/customers.js')

  customScript.setAttribute('type', 'application/javascript')

  document.head.appendChild(customScript)

  let customScript2 = document.createElement('script')

    customScript2.setAttribute('src', '/scripts/utils.js')

    customScript2.setAttribute('type', 'application/javascript')

    document.head.appendChild(customScript2)

}
}
</script>
  
  <style>
  .error {
    color: red;
}
  </style>